import { AdminSessionList, AdminSessionDetail } from '../types/sessions';
import { getApiBaseUrl } from './api';
import { getCoachApiBaseUrl, auth } from './firebase';

export class AuthError extends Error { }
export class NotAllocatedError extends Error { }
export class ForbiddenError extends Error { }

export async function apiFetch(
    path: string,
    init: RequestInit = {},
    opts: { forceRefresh?: boolean } = {},
): Promise<Response> {
    const baseUrl = getCoachApiBaseUrl();
    const user = auth?.currentUser;
    if (!user) throw new AuthError("not signed in");

    const token = await user.getIdToken(opts.forceRefresh ?? false);

    const headers = new Headers(init.headers);
    headers.set("Authorization", `Bearer ${token}`);
    if (init.body && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    const res = await fetch(path.startsWith(baseUrl) ? path : `${baseUrl}${path}`, { ...init, headers });

    if (res.status === 401) {
        // Token invalid/expired. Retry ONCE with forceRefresh
        if (!opts.forceRefresh) {
            return apiFetch(path, init, { forceRefresh: true });
        }
        throw new AuthError("unauthorized");
    }

    if (res.status === 403) {
        throw new ForbiddenError("Forbidden");
    }

    return res;
}


export const getSessions = async (params?: Record<string, string>): Promise<AdminSessionList> => {
    const baseUrl = getCoachApiBaseUrl();
    const url = new URL(`${baseUrl}/api/admin/sessions`);
    if (params) {
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    }

    try {
        const response = await apiFetch(url.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.warn("Using mock data for getSessions due to error:", error);
        throw error;
    }
};

export const getSessionDetail = async (id: string): Promise<AdminSessionDetail> => {
    const baseUrl = getCoachApiBaseUrl();

    try {
        const response = await fetch(`${baseUrl}/api/admin/sessions/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.warn(`Using mock data for getSessionDetail(${id}) due to error:`, error);
        throw error;
    }
};